import React, { useState } from "react";
import "./AccountActionsModal.scss";
import BaseModal from "../UI/BaseModal/BaseModal";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import UserAccountCreation from "../AccountActionsComponents/UserAccountCreation/UserAccountCreation";
import UserAccountTransfers from "../AccountActionsComponents/UserAccountTransfers/UserAccountTransfers";
import { useSelector } from "react-redux";

//Any changes to the tab panel or UI should be done here
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      // aria-labelledby={`simple-tab-${index}`}
      {...other}
      className="tab-panel-container"
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function AccountActionsModal({
  handleClose,
  open,
  selectedUserData,
  selectedUser,
  userHeader,
}) {
  const [value, setValue] = useState(0);
  const [testState, setTestState] = useState("test");

  // console.log(selectedUserData)
  // console.log(selectedUser)


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onChange = (e) => {
    setTestState(e.target.value);
  };

  const handleCloseModal = () => {
    setValue(0);
    handleClose();
  }

  // console.log(selectedUserData)

  const currentUser = useSelector(
    (state) => state.usersList.selectedUser
  );
  // console.log(currentUser);

  return (
    <BaseModal
      handleClose={handleCloseModal}
      open={open}
      width={"67%"}
      baseHeight={500}
      headerText={userHeader}
    >
      <Box sx={{ display: "flex", height: "100%" }}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          sx={{
            borderRight: 1,
            borderColor: "divider",
            //indicator color
            "& .MuiTabs-indicator": {
              backgroundColor: "#ff972c",
            },
            //selected tabs
            "& .MuiButtonBase-root.Mui-selected": {
              color: "#ff972c",
            },
            //non selected tabs
            "& .MuiButtonBase-root": {
              color: "rgba(0, 0, 0, 0.87)",
            },
          }}
        >
          <Tab label="Account Creation" />
          {/* <Tab label="Card Services" /> */}
          <Tab label="Transfers" />
          {/* <Tab label="Vouchers" />
          <Tab label="Loans" /> */}
        </Tabs>
        <TabPanel value={value} index={0}>
          <UserAccountCreation 
            selectedUserData={selectedUserData}
          />
        </TabPanel>
        {/* <TabPanel value={value} index={1}>
          <CardTabs />
        </TabPanel> */}
        <TabPanel value={value} index={1}>
          <UserAccountTransfers />
        </TabPanel>
      </Box>
    </BaseModal>
  );
}

export default AccountActionsModal;
